import { createSlice } from "@reduxjs/toolkit";

// Define initial state for the slice.
const initialState = {
  data: [],
  role: null,
  groupedPermissions: [],
  error: null,
  loading: false,
  permissionChange: null,
};

//  Define slice and it's reducer functions.
const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    resetState(state) {
      state.data = [];
      state.error = null;
      state.loading = true;
      state.role = null;
      state.groupedPermissions = [];
      state.permissionChange = { loading: false, error: null, data: null };
    },
    setRole(state, action) {
      state.role = action.payload;
    },
    setPermissionChange(state, action) {
      state.permissionChange = {
        loading: action.payload.loading,
        error: action.payload.error,
        data: action.payload.data,
      };
    },
    setGroupedPermissions(state, action) {
      state.groupedPermissions = action.payload;
    },
  },
});

export const roleAction = roleSlice.actions;

export default roleSlice;
